import React from "react"
import screenshot from './../../images/screenshot.png'

export const PristineImage = () => <div>
    <p>Pristine image:</p>
    <img src={screenshot} alt="pristine"/>
</div>
